<template>
  <!-- CHEYUWU 標誌（2026-10-04 由 PNG 換成內聯 SVG）：顏色走 currentColor，跟著所在的字色；
       第一條 path（.brand-wu）是 WU 符號本體，開場入座（runtime/intro-seat.mjs）量的就是它的 getBoundingClientRect()。 -->
  <svg class="brand-logo" :class="'brand-logo-' + variant" :viewBox="mark.viewBox" fill="currentColor" aria-hidden="true" focusable="false">
    <path class="brand-wu" :d="mark.wu" />
    <path v-if="mark.reg" class="brand-reg" :d="mark.reg" />
    <path v-for="(d, i) in mark.wordmark || []" :key="i" :d="d" />
  </svg>
</template>

<script setup>
import { computed } from 'vue'
import { PRIMARY, SYMBOL, SYMBOL_NOREG } from '@/runtime/brand-marks.mjs'

const props = defineProps({ variant: { type: String, default: 'primary' } })
const mark = computed(() => (props.variant === 'symbol' ? SYMBOL : props.variant === 'symbol-noreg' ? SYMBOL_NOREG : PRIMARY))
</script>
